import { ObjectDefinitions } from "../types/ObjectDefinitionTypes";

const objects: ObjectDefinitions[] = [
  {
    name: "microscopeMeiosis",
    image: "microscope",
    type: "interactableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        image: "microscope",
        buttons: [
          {
            icon: "EyeIcon",
            title: "microscope",
            type: "Modal",
            modal: "MicroscopeSorterNotebookModal",
          },
        ],
      },
      {
        name: "control",
        image: "microscopeSlide",
        buttons: [
          {
            icon: "EyeIcon",
            title: "microscope",
            type: "Modal",
            modal: "MicroscopeSorterNotebookModal",
          },
          {
            title: "microscope",
            icon: "Eject_slide",
            type: "UpdateState",
            stateUpdates: [
              {
                objectId: "slide_control",
                nextState: "default",
                position: {
                  x: 360,
                  y: 475,
                  z: 0,
                },
              },
              {
                objectId: "microscopeMeiosis",
                nextState: "empty",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "microscope",
    image: "microscope",
    type: "interactableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        image: "microscope",
        buttons: [
          {
            icon: "EyeIcon",
            title: "microscope",
            type: "Modal",
            modal: "Notebook_Modal",
          },
        ],
      },
      {
        name: "control",
        image: "microscopeSlide",
        buttons: [
          {
            icon: "EyeIcon",
            title: "microscope",
            type: "Modal",
            modal: "Notebook_Modal",
          },
          {
            title: "microscope",
            icon: "Eject_slide",
            type: "UpdateState",
            stateUpdates: [
              {
                objectId: "slide_control",
                nextState: "default",
                position: {
                  x: 360,
                  y: 475,
                  z: 0,
                },
              },
              {
                objectId: "microscope",
                nextState: "empty",
              },
            ],
          },
        ],
      },
      {
        name: "experimental",
        image: "microscopeSlide",
        buttons: [
          {
            icon: "EyeIcon",
            title: "microscope",
            type: "Modal",
            modal: "Notebook_Modal",
          },
          {
            title: "microscope",
            icon: "Eject_slide",
            type: "UpdateState",
            stateUpdates: [
              {
                objectId: "slide_experiment",
                nextState: "default",
                position: {
                  x: 410,
                  y: 475,
                  z: 0,
                },
              },
              {
                objectId: "microscope",
                nextState: "empty",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "asci_poster",
    image: "asci_poster",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "asci_poster",
      },
    ],
  },
  {
    name: "mitosis_poster",
    image: "mitosis_poster",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "mitosis_poster",
      },
      {
        name: "visited",
        image: "mitosis_poster",
      },
    ],
    buttons: [
      {
        icon: "EyeIcon",
        title: "mitosis_poster",
        type: "Modal",
        modal: "mitosis_poster",
      },
    ],
  },
  {
    name: "practice_assessment",
    image: "",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "",
      },
      {
        name: "completed",
        image: "",
      },
    ],
  },
  {
    name: "slide_rack",
    image: "slide_rack",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "slide_rack",
      },
    ],
  },
  {
    name: "mitosis_notebook",
    image: "mitosis_notebook",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "mitosis_notebook",
      },
      {
        name: "calculator",
        image: "mitosis_notebook",
        buttons: [
          {
            icon: "EyeIcon",
            title: "microscope",
            type: "Modal",
            modal: "Calculator",
          },
        ],
      },
    ],
  },
  {
    name: "meiosis_notebook",
    image: "mitosis_notebook",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "mitosis_notebook",
      },
      {
        name: "calculator",
        image: "mitosis_notebook",
        buttons: [
          {
            icon: "EyeIcon",
            title: "microscope",
            type: "Modal",
            modal: "NotebookCalculatorModal",
          },
        ],
      },
    ],
  },
  {
    name: "calculator",
    image: "calculator",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "calculator",
      },
      {
        name: "calculator",
        image: "calculator",
        buttons: [
          {
            icon: "EyeIcon",
            title: "Calculator",
            type: "Modal",
            modal: "Calculator",
          },
        ],
      },
    ],
  },
  {
    name: "meiosis_calculator",
    image: "calculator",
    type: "interactableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "calculator",
      },
      {
        name: "calculator",
        image: "calculator",
        buttons: [
          {
            icon: "EyeIcon",
            title: "Calculator",
            type: "Modal",
            modal: "NotebookCalculatorModal",
          },
        ],
      },
    ],
  },
  {
    name: "slide_control",
    image: "slide",
    type: "controllableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "slide",
      },
      {
        name: "microscope",
        image: "",
      },
    ],
  },
  {
    name: "slide_experiment",
    image: "slide",
    type: "controllableObject",
    defaultState: "default",
    states: [
      {
        name: "default",
        image: "slide",
      },
      {
        name: "microscope",
        image: "",
      },
    ],
  },
];

export default objects;
